import { render } from "./DiretorioList.vue?vue&type=template&id=4f8d1e9f"
import script from "./DiretorioList.vue?vue&type=script&lang=js"
export * from "./DiretorioList.vue?vue&type=script&lang=js"

import "./DiretorioList.vue?vue&type=style&index=0&id=4f8d1e9f&lang=css"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__